import { z } from 'zod';

/** Mirrors `backend/app/api/auth.py`'s `OwnerResponse`: the signed-in owner's identity, never
 * a credential. Returned by `POST /auth/login` and `GET /me` with the same shape on purpose,
 * so both can be validated and consumed identically. Kept separate from `ownerSchema` below so
 * the wire shape - what `tests/unit/contract/apiContract.test.ts` checks against the backend's
 * own OpenAPI schema - can be named without reaching into a `.transform()`. */
export const ownerResponseSchema = z.object({
  id: z.string(),
  email: z.string(),
  session_expires_at: z.string(),
});

export const ownerSchema = ownerResponseSchema.transform((owner) => ({
  id: owner.id,
  email: owner.email,
  sessionExpiresAt: owner.session_expires_at,
}));

export type Owner = z.infer<typeof ownerSchema>;
